import { ChartLineStackedIcon } from './ChartLineStackedIcon';

/**
 * author: Haley Halcyon
 * id B53C0CF7-F923-409F-91C3-420513E44231
 * name chart-line-stacked
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-line-stacked.svg
 * tags
 * - Math 
 */
export const WidgetLineStackedIcon = ChartLineStackedIcon;
export default WidgetLineStackedIcon